<template>
  <section class="width_100">
    <div class="service_hotline"
         :style="{'background-color':option.backgroundColor || '#323232','color':option.fontColor||'white'}">
      <p>
        <slot name="line_one"></slot>
      </p>
      <p>
        <slot name="line_two"></slot>
      </p>
      <p>
        <slot name="line_three"></slot>
      </p>
      <a :href="option.link_href || 'mailto:enquiry@cbsg.canon.com.cn'">
        <div class="learn_more_button">
          <slot name="learn_more_button"></slot>
        </div>
      </a>
    </div>
  </section>
</template>
<script>
export default {
  name: 'LearnMore',
  props: ['option'],
  data () {
    return {
    }
  },
  methods: {

  },
  created () {
  },
  mounted () {
    console.log(this.option)
  }
}
</script>
<style scoped lang="scss">
$p-size: 32px;
$p-size-small: 24px;
$span-size: 20px;
$span-size-small: 16px;
* {
  margin: 0;
  padding: 0;
}
a {
  text-decoration: none;
}
.banner_image {
  width: 100%;
}
.width_100 {
  width: 100%;
}
.width_50 {
  width: 50%;
}

.service_hotline {
  // background-color: #323232;
  color: #ffffff;
  padding: 50px 0 50px 0;
}
.service_hotline p {
  width: 70%;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  font-size: $p-size;
  font-weight: 600;
  text-align: center;
}
.service_hotline p:nth-of-type(1) {
  padding-bottom: 20px;
}

@media (max-width: 767px) {
  .service_hotline p {
    font-size: $p-size-small;
  }
}
@media (max-width: 544px) {
  .service_hotline {
    padding: 20px 0 20px 0;
  }
  .service_hotline p {
    font-size: 16px;
    width: 100%;
  }
  .learn_more_button {
    font-size: 14px !important;
    width: 130px !important;
  }
  .service_hotline p:nth-of-type(1) {
    padding-bottom: 0;
  }
  .service_hotline p:nth-of-type(3) {
    padding-bottom: 20px;
  }
}

.learn_more_button {
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  margin: 30px 0 20px 0;
  padding: 10px 0 10px 0;
  width: 200px;
  font-size: $span-size;
  font-weight: 600;
  color: #ffffff;
  background-color: #f2524e;
  border-radius: 30px;
  text-align: center;
}
@media (max-width: 544px) {
  .learn_more_button {
    margin: 0 0 0 0;
    padding: 10px 0 10px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/LearnMore.vue